import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=c6b43ff4&scoped=true"
import script from "./MoreInformation.vue?vue&type=script&lang=ts"
export * from "./MoreInformation.vue?vue&type=script&lang=ts"
import style0 from "./MoreInformation.vue?vue&type=style&index=0&id=c6b43ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b43ff4",
  null
  
)

export default component.exports